export enum ESignatureStep {
    INIT = 'init',
    SIGN = 'sign',
}
